// AUTO-GENERATED by tools/codegen (pnpm gen). Do not edit. Source: apps/client/src/state/slices/*.ts
import * as m0 from './slices/chat';
import * as m1 from './slices/core';
import * as m2 from './slices/decorate';
import * as m3 from './slices/fishing';
import * as m4 from './slices/fullscreen';
import * as m5 from './slices/inventory';
import * as m6 from './slices/mail';
import * as m7 from './slices/museum';
import * as m8 from './slices/notifications';
import * as m9 from './slices/safety';
import * as m10 from './slices/session';
import * as m11 from './slices/shop';
import * as m12 from './slices/title';
import * as m13 from './slices/villagers';
import * as m14 from './slices/world';
export const sliceModules = [m0, m1, m2, m3, m4, m5, m6, m7, m8, m9, m10, m11, m12, m13, m14] as const;
